export default "__VITE_ASSET__DCOswf5J__"